<template>
  <vs-row>
    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
      <form id="relationshipRuleNew" class="form form-vertical" onsubmit="return false">
      <div class="mb-5">
        <div class="header">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <vs-input 
                name="name"
                v-validate="'required'"
                class="mb-4 w-full"
                label-placeholder="Título da Régua de Relacionamento"
                v-model="name"
              ></vs-input>
              <span
                class="text-danger text-sm"
                v-show="errors.has('name')"
              >
                Informe um valor válido para o Título.
              </span>
            </div>
          </div>

          <div class="mb-8">
            <vs-row>
              <vs-col vs-w="3">
                <div class="w-full flex">
                  <span>É uma régua real time?</span>
                </div>
                <div class="w-full mt-4 flex">
                  <vs-switch v-model="isRealTime">
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>
              </vs-col>

              <vs-col vs-w="4">
                <div class="w-full flex">
                  <span>Deve realizar um disparo único por cliente?</span>
                </div>
                <div class="w-full mt-4 flex">
                  <vs-switch v-model="isUniqueDispatch">
                    <span slot="on">Sim</span>
                    <span slot="off">Não</span>
                  </vs-switch>
                </div>
              </vs-col>

              <vs-col vs-w="2">
                <div class="w-full flex">
                  <span>Categorias</span>
                </div>
                <div class="w-full mt-4 flex">
                  <vs-chip
                    @click="addCategory"
                    closable
                    close-icon="add"
                    style="font-size: 0.9rem;"
                  >
                    Adicionar Categoria
                  </vs-chip>
                </div>
                  <vs-chip
                      :key="`category-${index}`"
                      @click="removeGroup(categoryGroup)"
                      v-for="(categoryGroup, index) in categoryGroups"
                      closable
                      :color="categoryGroup.group.color_tag"
                      class="mt-3 mr-3"
                      style="font-size: 0.9rem;"
                    >
                      {{ categoryGroup.group.name }}
                  </vs-chip>
              </vs-col>

              <vs-col vs-w="3">
                <div class="w-full flex">
                  <span>Finaliza Em</span>
                </div>
                <div class="w-full mt-4 flex">
                  <flat-pickr
                    :config="configDateTimePicker"
                    v-model="stopsAt"
                    name="Finaliza Em"
                    placeholder="Escolha um dia"
                  />
                </div>
              </vs-col>

            </vs-row>
          </div>

          <div class="mb-8" v-if="isRealTime">
            <vs-row>
              <vs-col vs-w="3">
                <div class="mt-5">
                  <span>Qual o tipo de evento?:</span>
                </div>

                <v-select
                  class="w-full col" v-model="ruleEventType"
                  :options="ruleEventTypes" id="id" label="name"
                >
                  <template #option="{ name }">
                    <div class="name">
                      {{name}}
                    </div>
                  </template>
                </v-select>
              </vs-col>

            </vs-row>
          </div>
        </div>
      </div> <hr>

      <div>
        <div class="mt-5 text-center">
          <h6>Regras</h6>
          <p v-if="rules.length === 0">Nenhuma regra cadastrada</p>
        </div>

        <div>
          <component
            :index="index"
            @onRemoveRule="removeRule"
            :list="rulesAttributes[index]"
            v-for="(rule, index) in rules"
            :key="index"
            :is="rule"
            class="body"
          />
          <vs-button
            v-if="rules.length === 0"
            type="flat"
            @click.prevent="addRule(null)"
          >
            Adicionar Regra
          </vs-button>
          <vs-dropdown v-else vs-custom-content>
            <vs-button
              type="flat"
              class="btn-drop"
            >
              Adicionar Regra
            </vs-button>

            <vs-dropdown-menu>
              <vs-dropdown-item>
                <div class="flex text-center" @click.prevent="addRule('E')">
                  <p>E</p>
                </div>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <div class="flex text-center" @click.prevent="addRule('OU')">
                  <p>OU</p>
                </div>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <div class="w-full d-flex justify-content-flex-end">
        <vs-button @click.prevent="create">Salvar</vs-button>
      </div>
      </form>
    </vs-col>
    <div>
      <vs-popup title="Adicionar Categoria" :active.sync="popupCategoryActive">
        <table-category
          :categories="categoryData"
          @saveCategory="attachCategory"
          :popupCategoryActive="popupCategoryActive" 
        />
      </vs-popup>
    </div>
  </vs-row>
</template>
<script>
  import requestCategory from '@/http/requests/relationshipRuleCategory'
  import relationshipRuleCategoriesPivot from '@/http/requests/relationshipRuleCategoriesPivot'
  import requests from '@/http/requests/relationshipRules'
  import requestsRuleEventTypes from '@/http/requests/ruleEventTypes'
  import requestsRelationshipConditions from '@/http/requests/relationshipConditions'
  import Rule from "./Rule"
  import { formatRouteTenantPath } from '@/utils'
  import vSelect from 'vue-select'
  import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import TableCategory from './TableCategory.vue'

  export default {
    name: 'relationship-rules-new',
    provide() {
      return {
        $validator: this.$validator,
      }
    },
    components: { Rule, 'v-select': vSelect, flatPickr, TableCategory },
    async mounted() {
      requestsRuleEventTypes.fetch().then((response) => {
        this.ruleEventTypes = response.data.data.getRuleEventTypes
      })
      await this.fetchGroups();
    },
    data() {
      return {
        popupCategoryActive: false,
        rules: [],
        rulesAttributes: [],
        ruleEventTypes: [],
        name: '',
        isRealTime: false,
        isUniqueDispatch: false,
        ruleEventType: null,
        stopsAt: null,
        configDateTimePicker: {
          enableTime: false,
          noCalendar: false,
          dateFormat: "d/m/Y",
          locale: Portuguese,
          minDate: new Date()
        },
        categoryData: [],
        categoryGroups: [],
      }
    },
    watch: {
      popupCategoryActive: function (val) {
        if (val) {
          this.fetchGroups()
        }
      }
    },
    created () {},
    methods: {
      datePtToEng(date) {
        date = date.split('/')
        return `${date[2]}-${date[1]}-${date[0]}`
      },
      async fetchGroups(){
        const removeIds = this.categoryGroups.map(cg => cg.group.id)
        await requestCategory.fetchAll(removeIds).then(response => {
          const { relationshipRuleCategories } = response.data.data 
          this.categoryData = relationshipRuleCategories.map(group => ({
            id: null,
            group
          }))
        }).catch(err => {
          console.error(err)
        })
      },
      attachCategory(selectedCategories) {
        this.popupCategoryActive = false
        this.categoryGroups = [
          ...this.categoryGroups,
          ...selectedCategories
        ]
      },
      initValues(){
        const data ={
          popupCategoryActive: false,
          rules: [],
          rulesAttributes: [],
          ruleEventTypes: [],
          name: '',
          isRealTime: false,
          isUniqueDispatch: false,
          ruleEventType: null,
          stopsAt: null,
          configDateTimePicker: {
            enableTime: false,
            noCalendar: false,
            dateFormat: "d/m/Y",
            locale: Portuguese,
            minDate: new Date()
          },
          categoryData: [],
          categoryGroups: [],
        }
      },
      addRule (type = null) {
        this.rulesAttributes.push({
          relationship_condition_models_field_id: null,
          relationship_condition_models_operator_id: null,
          relationship_condition_models_data_type_id: null,
          relationship_condition_models_value: null,
          number: this.rules.length,
          parent_id: null,
          type
        })
        
        this.rules.push(Rule);
      },
      removeRule (idx) {
        this.rulesAttributes.splice(idx, 1)
        this.rules.splice(idx, 1)
      },
      removeGroup (group) {
        if (group.id) {
          requestCategory.delete(group.id).then(() => {
            this.categoryGroups.splice(this.categoryGroups.indexOf(group), 1)
          }).catch(err => {
            console.error(err)
          })
        } else {
          this.categoryGroups.splice(this.categoryGroups.indexOf(group), 1)
        }
      },
      create () {
        this.$validator.validateAll().then((valid) => {
          if(!valid) {
            return
          }
          this.$store.dispatch('setShowLoadingOverlay', true)

          let args = {
            name: this.name,
            is_real_time: this.isRealTime,
            is_unique_dispatch: this.isUniqueDispatch,
            repeat_each_time: 1,
            repeat_each_seasonality: 0,
            rule_event_type_id: this.ruleEventType !== null ? this.ruleEventType.id : null,
            stops_at: this.stopsAt !== null ? this.datePtToEng(this.stopsAt) : null
          }


          this.$store.dispatch('setShowLoadingOverlay', true)

          requests.create(args).then(async (response) => {
            this.initValues();
            const relationshipRule = response.data.data.createRelationshipRule
            const conditionIds = []

            try {
              for (const rule of this.rulesAttributes) {
                const condition = await requestsRelationshipConditions.create({
                  relationship_rule_id: relationshipRule.id,
                  relationship_condition_models_value: rule.relationship_condition_models_value,
                  relationship_condition_models_field_id: rule.relationship_condition_models_field_id,
                  relationship_condition_models_operator_id: rule.relationship_condition_models_operator_id,
                  relationship_condition_models_data_type_id: rule.relationship_condition_models_data_type_id,
                  type: rule.type === null ? null : (rule.type === 'E' ? 0 : 1),
                  parent_id: rule.parent_id ? conditionIds[conditionIds.length - 1] : null
                })

                conditionIds.push(condition.data.data.createRelationshipCondition.id)
              }
              for(const selectedCategories of this.categoryGroups){
                const data = relationshipRuleCategoriesPivot.add({ relationship_rule_id: relationshipRule.id, category_id: selectedCategories.group.id })
                }
            } catch (error) {
              console.log(error)
              this.$vs.notify({
                color: 'danger',
                title: 'Erro!',
                text: 'Erro ao adicionar condições da régua'
              })
              await requests.delete(relationshipRule.id)
              for (const relationshipConditionId of conditionIds) {
                await requestsRelationshipConditions.delete(relationshipConditionId)
              }

              this.$store.dispatch('setShowLoadingOverlay', false);
              return
            }

            this.$store.dispatch('setShowLoadingOverlay', false);

            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'A Régua de Relacionamento foi criada com sucesso'
            })
            this.$router.push(formatRouteTenantPath('/messaging/relationship-rules'))
          });
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })
      },
      addCategory(){
        this.popupCategoryActive = true;
      },
    },
    beforeRouteLeave(to, from, next) {
      this.popupCategoryActive = false
      setTimeout( ()=> {
        next();
      }, 1);
    },
  }
</script>

<style lang="scss">
  #relationshipRuleNew {
    .body {
      border: none;
      padding: 10px; 
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.090);
    }
  }
</style>
